import { ComponentPropsWithRef } from "react";

export const ActiveIcon = (props: ComponentPropsWithRef<"svg">) => (
  <svg viewBox="0 0 14 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M4.65987 11.0597L0.865118 7.26493C0.711627 7.11144 0.711627 6.86192 0.865118 6.70843L2.53462 5.03893C2.68811 4.88544 2.93763 4.88544 3.09112 5.03893L4.65987 6.60768C4.81336 6.76117 5.06288 6.76117 5.21637 6.60768L10.9089 0.915166C11.0624 0.761676 11.3119 0.761676 11.4654 0.915166L13.1349 2.58467C13.2884 2.73816 13.2884 2.98768 13.1349 3.14117L5.21637 11.0597C5.06288 11.2132 4.81336 11.2132 4.65987 11.0597Z"
      fill="currentColor"
    />
  </svg>
);
